// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import {
  createValidator,
  getBinding,
} from "#stdnum-runtime";

const vat: CountryValidator<"ES"> = createValidator(
  "es.vat",
  69,
);

export default vat;
export const compact = vat.compact;
export const format = vat.format;
export const validate = vat.validate;
export const generate = (): string =>
  vat.generate?.() ??
  (() => {
    throw new Error(
      "Validator es.vat cannot generate values",
    );
  })();
export const cifChecksum = (digits: string): number =>
  getBinding().esVatCifChecksum(digits);
